import { Controller } from 'stimulus';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class SocialButtonsController extends Controller {
  trackFacebookShare() {
    triggerCustomEvent(events.show_page.share_facebook, {
      resourceContentType: this.data.get('contentType'),
    });
  }

  trackPinterestShare() {
    triggerCustomEvent(events.show_page.share_pinterest, {
      resourceContentType: this.data.get('contentType'),
    });
  }

  trackTwitterShare() {
    triggerCustomEvent(events.show_page.share_twitter, {
      resourceContentType: this.data.get('contentType'),
    });
  }
}
